import { useSelector } from "react-redux";
import QrCodeAction from "@common/redux/actions/QrCodeAction";

const useQrCode = () => {
  const data = useSelector((state) => QrCodeAction.getStatePath(state));

  const { open, qrValue } = data;

  const setState = (data) => QrCodeAction.dispatch(data);

  const toggleVisibility = () => {
    open ? QrCodeAction.toggle(false) : QrCodeAction.toggle(true);
  };

  const toggleLocation = (location) =>
    setState({ qrValue: { ...qrValue, location } });

  const getQrCodeFromSiteCode = (options) => {
    const siteCode = options.find((x) => x.text === "Site Code");
    if (siteCode) {
      const qrValue = { siteCode: siteCode.defaultText };
      setState({ qrValue });
    }
  };

  const downloadQrCode = (qrCodeRef) => {
    // Get the SVG element
    const svgElement = qrCodeRef.current;

    if (!svgElement) return;

    // Get the SVG as a string
    const svgData = new XMLSerializer().serializeToString(svgElement);

    // Create a Blob from the SVG string
    const blob = new Blob([svgData], { type: "image/svg+xml" });

    // Create a download URL
    const url = URL.createObjectURL(blob);

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = url;
    link.download = `qrcode-${qrValue.siteCode}-${qrValue.location}.svg`;

    // Append to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object
    URL.revokeObjectURL(url);
  };

  return {
    ...data,
    toggleVisibility,
    toggleLocation,
    getQrCodeFromSiteCode,
    downloadQrCode,
  };
};
export default useQrCode;
